import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

interface Props {
  rows?: number;
}

/** Rows of a side card (timeline, members) while they load. */
const AccountListSkeleton = ({ rows = 2 }: Props) => (
  <Stack gap={1.5} aria-busy="true">
    {Array.from({ length: rows }, (_, index) => (
      <Stack key={index} direction="row" alignItems="center" gap={1.5}>
        <Skeleton variant="circular" width={32} height={32} />
        <Stack flex={1} gap={0.5}>
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="40%" />
        </Stack>
      </Stack>
    ))}
  </Stack>
);

export default AccountListSkeleton;
